export const VOICE_PIPELINE_LANGUAGES = {
    en: { code: 'en', label: 'ENG' },
    es: { code: 'es', label: 'ESP' },
};
export function getLanguageLabel(code) {
    if (!code)
        return '-';
    return (VOICE_PIPELINE_LANGUAGES[code]?.label ??
        code.toUpperCase());
}
/** Default page size for paginated voice pipeline session queries. */
export const VOICE_PIPELINE_DEFAULT_PAGE_SIZE = 25;
//# sourceMappingURL=voice-pipeline-language.js.map